import type { HttpError } from '@arcual/lib-app-platform';

export const handleHttpError = (_error: unknown) => {
  const error: HttpError = _error as HttpError;
  console.error('http request error:', error);
};
